/**
 * CL-RE-HOME-003 — Shared Property Record user-facing labels (presentation only).
 * Route id remains `home_record`; template keys unchanged.
 */

function safeStr(value) {
  return String(value ?? "").trim();
}

export const PROPERTY_RECORD_NAV_LABEL = "Property Record";
export const PROPERTY_RECORD_CHECKLIST_TITLE = "Confirm Property Record";
export const PROPERTY_RECORD_REVIEW_CTA = "Review Property Record";
export const PROPERTY_RECORD_EDIT_CTA = "Edit property details";

export function isPropertyRecordWorkspaceHref(href) {
  const h = safeStr(href);
  if (!h) return false;
  return (
    h.includes("tab=home_record")
    || h.includes("tab=home")
    || /\/home_record(?:\?|$)/.test(h)
  );
}

/** CTA label when navigation targets Property Record. */
export function resolvePropertyRecordReviewCtaLabel(href, fallback = "") {
  if (isPropertyRecordWorkspaceHref(href)) return PROPERTY_RECORD_REVIEW_CTA;
  return safeStr(fallback) || null;
}

export function applyPropertyRecordCtaToOverviewAction(action) {
  if (!action || typeof action !== "object") return action;
  const href = safeStr(action.href);
  const cta = resolvePropertyRecordReviewCtaLabel(href, action.ctaLabel || action.nextAction);
  if (!cta) return action;
  return { ...action, ctaLabel: cta };
}
